import React from "react";
import "./Footer.css";
import logo from "../../assets/logo.png";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      {/* background glow */}
      <div className="footer__bg" aria-hidden="true" />

      <div className="container footer__inner">
        {/* Brand */}
        <div className="footer__brand">
          <div className="footer__brandRow">
            <img src={logo} alt="New Alubomulla Trade Center" className="footer__logo" />
            <div>
              <h5 className="footer__brandName">New Alubomulla Trade Center</h5>
              <p className="footer__tag">Quality • Value • Service</p>
            </div>
          </div>
          <p className="footer__desc">
            Your one-stop shop for hardware, tools, paint, plumbing, and building
            materials trusted by Panadura.
          </p>
        </div>

        {/* Links */}
        <nav className="footer__col">
          <h6 className="footer__title">Quick Links</h6>
          <ul className="footer__links">
            <li><a href="/" className="footer__link">Home</a></li>
            <li><a href="/products" className="footer__link">Products</a></li>
            <li><a href="#services" className="footer__link">Services</a></li>
            <li><a href="#about" className="footer__link">About</a></li>
            <li><a href="#contact" className="footer__link">Contact</a></li>
          </ul>
        </nav>

        {/* Contact */}
        <div className="footer__col">
          <h6 className="footer__title">Get in Touch</h6>
          <ul className="footer__list">
            <li><i className="bi bi-geo-alt"></i> 150E Horana Rd, Panadura</li>
            <li>
              <i className="bi bi-telephone"></i>
              <a href="tel:+94776500580" className="footer__link"> +94 77 6500580</a>
            </li>
            <li>
              <i className="bi bi-envelope"></i>
              <a href="mailto:alubomullahardware@gmail.com" className="footer__link"> alubomullahardware@gmail.lk</a>
            </li>
          </ul>
          <div className="footer__social">
            <a href="https://www.facebook.com/share/1GuYuXSy1i/?mibextid=wwXIfr" aria-label="Facebook" className="social-btn"><i className="bi bi-facebook"></i></a>
            <a href="https://api.whatsapp.com/send/?phone=94776500580&text&type=phone_number&app_absent=0" aria-label="WhatsApp" className="social-btn"><i className="bi bi-whatsapp"></i></a>
          </div>
        </div>

        {/* Subscribe */}
        <div className="footer__col">
          <h6 className="footer__title">Stay Updated</h6>
          <p className="footer__muted">Get offers and product tips. No spam.</p>
          
          <div className="footer__credit">
            Crafted by{" "}
            <a
              href="https://www.auricodesolutions.com/"
              target="_blank"
              rel="noreferrer"
              className="footer__link accent"
            >
              Auricode Solutions
            </a>
          </div>
        </div>
      </div>

      <div className="container footer__bottom">
        <p>© {year} New Alubomulla Trade Center. All rights reserved.</p>
        <p className="footer__muted">Built for builders.</p>
      </div>
    </footer>
  );
}

export default Footer;
